import {Fill,Text, Stroke, Style,Icon} from 'ol/style';
import LRUCache from 'lru-cache';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
import { useState, useEffect } from 'react';
// import { VectorSource } from 'ol/source';

import _, { values } from 'lodash';
import axios from 'axios';
import { admin_boundary_base_url,admin_boundary_layersName,featureName,level_arr, RDSE_COUNT } from '../../../Essentials/variables';
import {stateBoundaryVectorSource,stateBoundaryStyle} from './state';


// let Token=localStorage.getItem('token')
let mapRdse = new Map();

function fetchTokenFromLocalStorage() {
  const token = localStorage.getItem('token');
  return token;
}

function getUrl(selection,level){
    var ret = admin_boundary_base_url;
    for(var i = 0;i <= _.indexOf(level_arr,level) ; i++){
        ret = ret +'/'+ selection[level_arr[i]];
    }
    // console.log(ret);
    return ret; 
}

// function getVectorSource(level,selection){
//     var vectorSource =  new VectorSource({
//         url: getUrl(selection,level),
//         format: new TopoJSON({
//           layers: [admin_boundary_layersName[level]],
//         }),
//         overlaps: true,
//       });
//     return vectorSource;
// } 
/////////////////////////////
function getVectorSource(level, selection) {
  let Token = fetchTokenFromLocalStorage();
  
  var vectorSource = new VectorSource({
    url: getUrl(selection, level),
    format: new TopoJSON({
      layers: [admin_boundary_layersName[level]],
    }),
    overlaps: true,
    loader: function (extent, resolution, projection) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', vectorSource?.getUrl());
      xhr.setRequestHeader('x-access-token',  Token);
      xhr.onload = function () {
        if (xhr.status == 200) {
          vectorSource.addFeatures(
            vectorSource.getFormat()?.readFeatures(xhr.responseText, {
              dataProjection: projection,
              featureProjection: vectorSource.getProjection(),
            })
          );
        } else {
          console.error('Request failed. Status: ' + xhr.status);
        }
      };
      xhr.send();
    },
  });
  return vectorSource;
}


////////////////////////////////


export function adminBoundary(level,selection,optionSelection,rdseData){
  // console.log("RDSEDATA", rdseData);
  
  let result = _.find(rdseData, function(obj) {
    
    if (obj?.emp_desg_cd==='RSE' || obj?.emp_desg_cd==='RTL') {
      if(mapRdse.get(obj?.subdist_name)===3){  mapRdse.set(obj?.subdist_name,2);}
      else if(mapRdse.get(obj?.subdist_name)===2){  mapRdse.set(obj?.subdist_name,2);}
      else mapRdse.set(obj?.subdist_name,1);
    }
    else if (obj?.emp_desg_cd==='RRM') {
      // console.log(obj.subdist_name);
      if(mapRdse.get(obj?.subdist_name)===1){  mapRdse.set(obj?.subdist_name,2);}
      else if(mapRdse.get(obj?.subdist_name)===2){  mapRdse.set(obj?.subdist_name,2);}
      else mapRdse.set(obj?.subdist_name,3);
    }
    // console.log(obj.subdist_name,"Loop->",mapRdse.get(obj.subdist_name));
});


  if(!selection?.State && !selection?.District && !selection?.Sub_District && !selection?.Village)
      return new VectorLayer({
        source : stateBoundaryVectorSource,
        style: stateBoundaryStyle(optionSelection)
      });
     else{
      var vectorSource = getVectorSource(level,selection);

      return new VectorLayer({
          source: vectorSource,
          style: function (feature) {
            // console.log("Previous implementation ",feature);
            // if(feature.get("STATE_NAME") && feature.get("DIST_NAME") && feature.get("SUBDIST_NAME")){ getRdseStyle(feature); }
            // console.log(feature.get("STATE_NAME")," ",feature.get("DIST_NAME")," ",feature.get("SUBDIST_NAME"));
            // console.log(_.replace(feature.get(featureName[level]),' District',''),featureName[level]);
            if(feature.get("STATE_NAME") && feature.get("DIST_NAME") && feature.get("SUBDIST_NAME") && !feature.get("VIL_NAME")){
                // console.log(feature.get("SUBDIST_NAME"),"->",mapRdse.get(feature.get("SUBDIST_NAME")));
                let svgpath;
                if(mapRdse.get(feature.get("SUBDIST_NAME"))===2){ svgpath= 'data/new/rdseboth.svg'}
                else if(mapRdse.get(feature.get("SUBDIST_NAME"))===3){ svgpath= 'data/new/redrdse.svg'}
                else if(mapRdse.get(feature.get("SUBDIST_NAME"))===1){ svgpath='data/new/rdse-icon.svg' }
                else { svgpath='data/new/invisible.svg' }
                // console.log(svgpath);
    
                return [new Style({
                  text: new Text({
                    text: _.replace(feature.get(featureName[level]),' District',''),
                    //text: feature.get(featureName[level]),
                    font: 'bold 12px Arial',
                  }),
                  stroke: new Stroke({
                    color: 'rgba(1, 0, 0, 1)',
                    // color: 'rgba(0, 149, 62, 1)',
                    width: 1,
                  }),
                  
                  fill : new Fill({
                    color: 'rgba(0,0,0,0.01)',
                  })
              }),new Style({
                geometry:feature.getGeometry().getInteriorPoints(),
                image: new Icon({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: svgpath,
                backgroundColor:'rgba(0, 0, 0, 0.1)',
                color: 'rgba(0, 0, 0, 0.1)',
                scale: 0.7
              })})]
              
            }
            else{
              return new Style({
                  text: new Text({
                    text: _.replace(feature.get(featureName[level]),' District',''),
                    //text: feature.get(featureName[level]),
                    font: 'bold 12px Arial',
                  }),
                  stroke: new Stroke({
                    color: 'rgba(1, 0, 0, 1)',
                    // color: 'rgba(0, 149, 62, 1)',
                    width: 1,
                  }),
                  fill : new Fill({
                    color: 'rgba(0,0,0,0.01)',
                  })
              });
            }
          }
      });
     }    
}